// extracted by mini-css-extract-plugin
export var colorSquare = "_sk-0";
export var danger = "_sk-5";
export var lightPink = "_sk-8";
export var neutralBlue = "_sk-7";
export var neutralYellow = "_sk-6";
export var normal = "_sk-1";
export var primary = "_sk-2";
export var primaryLight = "_sk-3";
export var solidBlack = "_sk-g";
export var solidGreen = "_sk-b";
export var solidLightBlue = "_sk-d";
export var solidNavy = "_sk-c";
export var solidOrange = "_sk-f";
export var solidPink = "_sk-e";
export var solidRed = "_sk-9";
export var solidYellow = "_sk-a";
export var success = "_sk-4";